import type { Lang } from './config'

// Dicionário de UMA área: mesmas chaves nos 3 idiomas.
export type AreaDict = Record<Lang, Record<string, string>>

// Auto-carrega TODOS os dicionários em src/i18n/dict/*.ts (default export = AreaDict).
// Assim cada tela tem seu arquivo próprio e novos idiomas/áreas não colidem entre si.
const modules = import.meta.glob('./dict/*.ts', { eager: true }) as Record<string, { default: AreaDict }>

const merged: Record<Lang, Record<string, string>> = { en: {}, 'pt-BR': {}, es: {} }
for (const mod of Object.values(modules)) {
  const d = mod.default
  if (!d) continue
  ;(['en', 'pt-BR', 'es'] as Lang[]).forEach((lang) => Object.assign(merged[lang], d[lang] ?? {}))
}

export const messages = merged
